import { render } from "./TweetToday.vue?vue&type=template&id=418f0108"
import script from "./TweetToday.vue?vue&type=script&lang=js"
export * from "./TweetToday.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__